<template>
    <form-modal
        :open="isEditModalOpen"
        :heading="$t('modals.category.edit')"
        entity="category"
        mode="edit"
        :submit-label="$t('modals.category.save')"
        :fields="fields"
        :values="category"
        :info="[{ label: $t('fields.id'), value: category.category_id }]"
        save-url="/edit-category.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isEditModalOpen', $event)"
        @opened="fetchCategoryDetails"
        @saved="$emit('category-saved')"
    />
</template>

<script>
import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';
import FormModal from '@/components/common/FormModal.vue';
import { t } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isEditModalOpen: {
            type: Boolean,
            required: true,
        },
        selectedCategory: {
            type: Object,
            default: () => ({ category_id: null, category_name: null }),
        },
    },
    emits: ['update:isEditModalOpen', 'category-saved'],
    setup(props) {
        const category = ref({});
        const fields = computed(() => [
            { key: 'category_name', label: t('fields.categoryName'), type: 'text', required: true },
        ]);
        const buildPayload = (form) => ({
            categoryId: form.category_id,
            categoryName: form.category_name,
        });

        const fetchCategoryDetails = () => {
            category.value = {};
            apiClient.get('/get-category-details.php?categoryId=' + props.selectedCategory.category_id)
                .then((response) => {
                    category.value = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching category details:', error);
                });
        };

        return { category, fields, buildPayload, fetchCategoryDetails };
    },
};
</script>
